__turbopack_context__.v({
  "button": "hamburger-button-module-scss-module__Xxqk2W__button",
  "button-active": "hamburger-button-module-scss-module__Xxqk2W__button-active",
  "close-icon": "hamburger-button-module-scss-module__Xxqk2W__close-icon",
  "open-icon": "hamburger-button-module-scss-module__Xxqk2W__open-icon",
});
